import React from "react";
import { CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";

const AboutCompany = () => {
  return (
    <section className="bg-gray-50 py-12 px-4 sm:px-6 lg:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Image */}
        <div data-aos="fade-right">
          <img
            src="https://naveen6757.neocities.org/building_project/aboutimg.jpg"
            alt="Modern House"
            className="rounded-xl shadow-md w-full h-auto object-cover"
          />
        </div>

        {/* Content */}
        <div data-aos="fade-left">
          <div className="inline-block">
            <h2 className="text-3xl font-bold text-blue-700 mb-2">
              About Our Company
            </h2>
            <div
              className="w-20 h-1 bg-[#6FEF34] mb-4 mx-auto blink-underline"
              style={{ width: "170px" }}
            ></div>
          </div>

          <p className="text-gray-500 mb-4">Building excellence since 2010</p>

          <p className="text-gray-700 mb-6 leading-relaxed">
            Sanctus property pvt ltd is a leading property management and
            construction service provider with over a decade of experience in
            the industry. We specialize in building renovation, civil contracts,
            and architectural design.
          </p>

          {/* Features */}
          <ul className="space-y-3 mb-6">
            {[
              "Professional Team",
              "Quality Materials",
              "On-time Delivery",
              "Customer Satisfaction",
            ].map((item, index) => (
              <li key={index} className="flex items-center text-gray-800">
                <CheckCircle className="text-blue-600 w-5 h-5 mr-3 blink-underline2" />
                {item}
              </li>
            ))}
          </ul>

          {/* Read More Button */}
          <Link
            to="/about"
            className="inline-block bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-6 rounded shadow-md transition duration-300"
          >
            Read More
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutCompany;
